"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _faFacebookF = require("@fortawesome/free-brands-svg-icons/faFacebookF");

var _faLink = require("@fortawesome/free-solid-svg-icons/faLink");

var _faSquare = require("@fortawesome/free-solid-svg-icons/faSquare");

var _faTwitter = require("@fortawesome/free-brands-svg-icons/faTwitter");

var _faViber = require("@fortawesome/free-brands-svg-icons/faViber");

var _faWhatsapp = require("@fortawesome/free-brands-svg-icons/faWhatsapp");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _reactIntl = require("react-intl");

require("./SharingButtons.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  _setPrototypeOf(subClass.prototype, superClass && superClass.prototype);

  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.getPrototypeOf || function _getPrototypeOf(o) {
    return o.__proto__;
  };

  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SharingButtons =
/*#__PURE__*/
function (_React$PureComponent) {
  function SharingButtons() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, SharingButtons);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SharingButtons)).call.apply(_getPrototypeOf2, [this].concat(args))), _defineProperty(_defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      copied: false
    }), "handleShareLink", function () {
      var el = document.createElement('input');
      el.value = _this.props.sharingUrl;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      var selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);

      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }

      _this.setState({
        copied: true
      });
    }), _temp));
  }

  _createClass(SharingButtons, [{
    key: "render",
    value: function render() {
      var formatMessage = this.context.intl.formatMessage;
      var _this$props = this.props,
          title = _this$props.title,
          sharingUrl = _this$props.sharingUrl,
          className = _this$props.className;
      var copied = this.state.copied;
      var isMobile = false;

      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
        isMobile = true;
      }

      return _react.default.createElement("div", {
        className: "sharing_buttons_container ".concat(className)
      }, _react.default.createElement("ul", {
        className: "list-unstyled m-0"
      }, _react.default.createElement("li", null, _react.default.createElement("a", {
        href: "https://www.facebook.com/sharer/sharer.php?u=".concat(sharingUrl),
        target: "_blank",
        rel: "noopener noreferrer"
      }, _react.default.createElement("span", {
        className: "fa-stack fa-1x"
      }, _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _faSquare.faSquare,
        className: "fa-stack-2x"
      }), _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _faFacebookF.faFacebookF,
        className: "fa-stack-1x fa-inverse"
      })), _react.default.createElement(_reactIntl.FormattedMessage, {
        id: "share_buttons_facebook"
      }))), _react.default.createElement("li", null, _react.default.createElement("a", {
        href: "https://twitter.com/intent/tweet?text=".concat(formatMessage({
          id: 'share_buttons_text'
        }, {
          title: title,
          link: ''
        }), "&url=").concat(sharingUrl),
        target: "_blank",
        rel: "noopener noreferrer"
      }, _react.default.createElement("span", {
        className: "fa-stack fa-1x"
      }, _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _faSquare.faSquare,
        className: "fa-stack-2x"
      }), _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _faTwitter.faTwitter,
        className: "fa-stack-1x fa-inverse"
      })), _react.default.createElement(_reactIntl.FormattedMessage, {
        id: "share_buttons_twitter"
      }))), _react.default.createElement("li", null, _react.default.createElement("a", {
        href: isMobile ? "whatsapp://send?text=".concat(formatMessage({
          id: 'share_buttons_text'
        }, {
          title: title,
          link: sharingUrl
        })) : "https://web.whatsapp.com/send?text=".concat(formatMessage({
          id: 'share_buttons_text'
        }, {
          title: title,
          link: sharingUrl
        })),
        "data-action": "share/whatsapp/share",
        target: "_blank",
        rel: "noopener noreferrer"
      }, _react.default.createElement("span", {
        className: "fa-stack fa-1x"
      }, _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _faSquare.faSquare,
        className: "fa-stack-2x"
      }), _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _faWhatsapp.faWhatsapp,
        className: "fa-stack-1x fa-inverse"
      })), _react.default.createElement(_reactIntl.FormattedMessage, {
        id: "share_buttons_whatsapp"
      }))), isMobile && _react.default.createElement("li", null, _react.default.createElement("a", {
        href: "viber://forward?text=".concat(formatMessage({
          id: 'share_buttons_text'
        }, {
          title: title,
          link: sharingUrl
        }))
      }, _react.default.createElement("span", {
        className: "fa-stack fa-1x"
      }, _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _faSquare.faSquare,
        className: "fa-stack-2x"
      }), _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _faViber.faViber,
        className: "fa-stack-1x fa-inverse"
      })), _react.default.createElement(_reactIntl.FormattedMessage, {
        id: "share_buttons_viber"
      }))), _react.default.createElement("li", null, _react.default.createElement("button", {
        onClick: this.handleShareLink,
        className: "btn btn-link m-0 p-0"
      }, _react.default.createElement("span", {
        className: "fa-stack fa-1x"
      }, _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _faSquare.faSquare,
        className: "fa-stack-2x"
      }), _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _faLink.faLink,
        className: "fa-stack-1x fa-inverse"
      })), _react.default.createElement(_reactIntl.FormattedMessage, {
        id: "share_buttons_link"
      })), copied && _react.default.createElement("span", {
        className: "text-success m-1"
      }, _react.default.createElement(_reactIntl.FormattedMessage, {
        id: "share_buttons_link_copied"
      })))));
    }
  }]);

  _inherits(SharingButtons, _React$PureComponent);

  return SharingButtons;
}(_react.default.PureComponent);

exports.default = SharingButtons;

_defineProperty(_defineProperty(_defineProperty(SharingButtons, "propTypes", {
  className: _propTypes.default.string,
  sharingUrl: _propTypes.default.string,
  title: _propTypes.default.string
}), "contextTypes", {
  intl: _reactIntl.intlShape
}), "defaultProps", {
  className: '',
  sharingUrl: window.location.href,
  title: ''
});